import apiClient from "./apiClient";
import { Stock, StockAvailabilityRequest, StockAvailabilityResponse } from "../types";

interface StocksResponse {
  warehouse_id: number;
  stocks: Stock[];
}

export const fetchStocksByWarehouse = async (
  warehouseId: number, 
  productIds: number[]
): Promise<Stock[]> => {
  try {
    if (!productIds.length) {
      return [];
    }

    const response = await apiClient.get<StocksResponse>(
      `/api/warehouses/stocks?warehouse_id=${warehouseId}`,
      {
        data: { product_ids: productIds }
      }
    );
    
    return response.data.stocks || [];
  } catch (error) {
    console.error(`Ошибка при получении остатков для склада ${warehouseId}:`, error);
    throw new Error("Не удалось получить остатки товаров");
  }
};

export const checkStockAvailability = async (
  warehouseId: number,
  items: StockAvailabilityRequest[]
): Promise<StockAvailabilityResponse> => {
  try {
    if (!items.length) {
      throw new Error("Список товаров пуст");
    }

    const response = await apiClient.post<StockAvailabilityResponse>(
      `/api/warehouses/check-availability?warehouse_id=${warehouseId}`,
      { items }
    );
    
    return response.data;
  } catch (error) {
    console.error(`Ошибка при проверке доступности в магазине ${warehouseId}:`, error);
    throw new Error("Не удалось проверить доступность товаров");
  }
};

export const updateProductStocks = async (
  warehouseId: number,
  productIds: number[]
): Promise<Stock[]> => {
  try {
    return await fetchStocksByWarehouse(warehouseId, productIds);
  } catch (error) {
    console.error("Ошибка при обновлении остатков товаров:", error);
    return [];
  }
};

